import { render, staticRenderFns } from "./CreateCustomerUploadEdit.vue?vue&type=template&id=635b6499&scoped=true&"
import script from "./CreateCustomerUploadEdit.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerUploadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b6499",
  null
  
)

export default component.exports